export default __webpack_public_path__ + "static/media/saitLogo.cb12e72e.png";